import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { MpesaTransactionManagement } from '../components/MpesaTransactionManagement';
import PageHeader from '../components/PageHeader';

const MpesaTransactions: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <PageHeader 
        title="M-Pesa Transaction Management"
        subtitle="Monitor and manage all M-Pesa payment transactions across the system"
      />
      <Box sx={{ mt: 3 }}>
        <MpesaTransactionManagement />
      </Box>
    </Container>
  );
};

export default MpesaTransactions; 